import { ActionList } from '@/components/DragAndDrop';
import ActionListItem, { ActionListItemProps } from '@/components/DragAndDrop/ActionListItem';
import EmptyActionList from '@/components/EmptyActionList';
import { IconChevronDown } from '@/theme/icons';
import { Action, RecurringWeekContext } from '@/types/actions';
import { validateRecurrence } from '@/utils/events';
import rem from '@/utils/rem';
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Flex, Text } from '@chakra-ui/react';
import { isEmpty, size } from 'lodash';

export type ActionListStatusGroupProps = {
  className?: string;
  actions: Action[];
  title: string;
  emptyMessage: string;
  dndPayload?: ActionListItemProps['dndPayload'];
} & Pick<ActionListItemProps, 'onDeleteAction' | 'onClickCreateBlock'> & {
    recurringWeekContext?: RecurringWeekContext | null;
    backgroundColor?: string;
  };

function ActionListStatusGroup({
  actions,
  className,
  title,
  emptyMessage,
  dndPayload,
  recurringWeekContext = null,
  backgroundColor,
  ...actionListItemProps
}: ActionListStatusGroupProps) {
  return (
    <Accordion width="full" marginTop={rem(16)} allowToggle reduceMotion>
      <AccordionItem>
        <AccordionButton className={className} gap={rem(4)} padding="0">
          <Flex flex="1" textAlign="left">
            <Text textStyle="xsmall" color="text-secondary" textTransform="uppercase">
              {size(actions)} {title}
            </Text>
          </Flex>
          <AccordionIcon as={IconChevronDown} width={rem(14)} height={rem(14)} color="text-primary" />
        </AccordionButton>
        <AccordionPanel marginTop={rem(8)} padding={0} paddingBottom={4}>
          <ActionList isEmpty={isEmpty(actions)} emptyListComponent={<EmptyActionList message={emptyMessage} />}>
            {actions.map((action, index) => (
              <ActionListItem
                key={action.id}
                disabled
                dndPayload={dndPayload ? { ...dndPayload, index } : undefined}
                item={action}
                index={index}
                readOnly
                recurringWeekContext={recurringWeekContext}
                disableRecurringStatusChanges={validateRecurrence(action.event?.recurrence)}
                {...actionListItemProps}
                {...(backgroundColor !== undefined ? { backgroundColor } : {})}
              />
            ))}
          </ActionList>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}

export default ActionListStatusGroup;
